import { baseTheme } from '~base-theme';
var formTheme = {
  form: {
    input: {
      light: {
        backgroundColor: '#3D3D3D',
        backgroundColorFocus: '#424242',
        borderColor: baseTheme.base.grays.grayLight,
        borderColorFocus: '#90caf9',
        color: baseTheme.base.grays.grayLightest,
        colorDisabled: baseTheme.base.grays.gray
      },
      dark: {
        backgroundColor: '#F2F2F2',
        backgroundColorFocus: '#ECECEC',
        borderColor: baseTheme.base.grays.grayLight,
        borderColorFocus: '#0069d9',
        color: baseTheme.base.grays.grayDarkest,
        colorDisabled: baseTheme.base.grays.gray
      },
      height: 54,
      heightNoLabel: 48,
      fontSize: 16,
      borderRadius: 4
    },
    label: {
      light: {
        color: baseTheme.base.grays.grayLight,
        colorFilled: baseTheme.base.grays.gray,
        colorFocus: '#90caf9',
        colorDisabled: baseTheme.base.grays.gray
      },
      dark: {
        color: baseTheme.base.grays.grayDark,
        colorFilled: baseTheme.base.grays.gray,
        colorFocus: '#0069d9',
        colorDisabled: baseTheme.base.grays.gray
      },
      fontSize: 16,
      fontSizeFocus: 11
    },
    select: {
      light: {
        backgroundColor: 'rgba(255,255,255,0.05)',
        optionColor: baseTheme.base.grays.grayLightest
      },
      dark: {
        backgroundColor: 'rgba(0,0,0,0.05)',
        optionColor: baseTheme.base.grays.grayDarkest
      }
    },
    checkbox: {
      light: {
        backgroundColor: 'transparent',
        backgroundColorChecked: 'transparent',
        borderColor: '#ffffff',
        borderColorChecked: '#ffffff',
        colorChecked: '#ffffff',
        colorDisabled: '#f2f2f2',
        colorDisabledChecked: '#c5c6c6',
        indicatorColor: '#ffffff'
      },
      dark: {
        backgroundColor: '#f2f2f2',
        backgroundColorChecked: '#1b9ddb',
        borderColor: '#666666',
        borderColorChecked: '#1b9ddb',
        colorChecked: '#1b9ddb',
        colorDisabled: '#f2f2f2',
        colorDisabledChecked: '#c5c6c6',
        indicatorColor: '#ffffff'
      },
      size: {
        default: '1rem',
        lg: '1.375rem'
      },
      label: {
        fontSize: {
          default: '0.875rem',
          lg: '1rem'
        },
        color: {
          light: {
            default: '#ffffff',
            disabled: '#c5c6c6'
          },
          dark: {
            default: 'inherit',
            disabled: '#c5c6c6'
          }
        }
      }
    },
    switch: {
      backgroundColorOn: '#6dbe45',
      backgroundColorOff: '#ffffff',
      borderColor: '#CCCCCC',
      colorOn: '#ffffff',
      colorOff: '#bbbbbb',
      backgroundColorToggle: '#f7f7f7',
      borderColorToggle: '#ececec',
      size: {
        default: '2.5rem',
        sm: '1.9375rem',
        xs: '1.5625rem'
      },
      label: {
        light: {
          color: '#ffffff'
        },
        dark: {
          color: 'inherit'
        }
      }
    },
    currency: {
      light: {
        color: '#ffffff',
        colorChecked: '#1b9ddb'
      },
      dark: {
        color: '#bbbbbb',
        colorChecked: '#1b9ddb'
      },
      size: '2.375rem'
    },
    legend: {
      light: {
        color: '#ffffff'
      },
      dark: {
        color: '#1b9ddb'
      }
    },
    error: {
      light: {
        backgroundColor: 'transparent'
      },
      dark: {
        backgroundColor: 'transparent'
      },
      color: '#d90000'
    }
  }
};
export default formTheme;